const FILTER_PLACEHOLDER_TEXT = 'Start typing to search';

export { FILTER_PLACEHOLDER_TEXT };
